import { useRegionManagerImportMutation } from '@api/import/api';
import { hasOwnPropertyTS } from '@utils/typescriptGuards';
import LoadingApp from 'components/base-elements/loading/LoadingApp';
import DroppableFileInput from '@pages/upload-pages/shared-components/DroppableFileInput';
import UploadSuccess from '@pages/upload-pages/shared-components/UploadSuccess';
import UploadError from '@pages/upload-pages/shared-components/UploadError';



interface UploadFileProps {
	uploadReset: () => void,
}


export const UploadFile = (props: UploadFileProps) => {
	const { uploadReset } = props;

	const [ updateFile, { data, isSuccess, isError, error, isLoading } ] = useRegionManagerImportMutation();

	
	if (isLoading) return (
		<LoadingApp />
	)

	
	if (isError) return (
		<UploadError
			errorMessage={error && hasOwnPropertyTS(error, 'message') && typeof error.message === 'string'
				? error.message
				: error && hasOwnPropertyTS(error, 'error') && typeof error.error === 'string'
				? error.error
				: null}
			uploadReset={uploadReset} />
	)

	
	if (isSuccess && data === true) return (
		<UploadSuccess uploadReset={uploadReset} />
	)
	

	return (
		<DroppableFileInput uploadFile={updateFile} />
	)
}

export default UploadFile;